module Meevo.Plugins.Register {

    class OnHoldController {
        searchResults: any;

        static $inject = ['registerContext', "meevo.components.common.DataService", "meevo.AppSettings", "$mdDialog"];
        product;
        constructor(public registerContext: RegisterContext, public dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog: angular.material.IDialogService) {

            this.searchResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "sale");          

            let request = {
                pageNumber: 1,
                itemsPerPage: 20,
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
                isOnHold: true
            };

            this.searchResults.initSearch(request);
        }

        close() {
            this.$mdDialog.hide();
        }

        selectOnHold(onHold) {
            this.registerContext.sale.mergeOnHoldId = onHold.id;
            this.registerContext.saleNotesMerge(onHold.sale.saleNotes);
            this.registerContext.recalculateSale();
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.OnHoldController", OnHoldController);
}